import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getByAtencion = async ( tokenAtencion ) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const query = `
    query AllAtenmedica($tokenAtencion: String) {
      allAtenmedica(tokenAtencion: $tokenAtencion) {
        total
        status
        message
        atcm {
          id
          token
          descansomedicoSet {
              id
              token
              diasdescanso
              aislamiento
              actividadlab
              contingencia
              empresa
              tipodiagnostico {
                id
                descripcion
              }
              residencia {
                id
                callePrincipal
              }
              observacion
            }

        }
      }
    }
  `;


  const variables = { tokenAtencion };

  try {

    const response = await axios.post(rutas.axios + "api", { query, variables });

    const response2 = response.data.data.allAtenmedica;
    if (response2.status !== "success") return null;
    if (response2.atcm.length === 0) return null;
    if (response2.atcm[0].descansomedicoSet.length === 0) return null;

    const data = response2.atcm[0].descansomedicoSet[0];
    return data;

  }catch (error) {
    console.error('error al obtener descanso medico por atencion', error);
    return null
  }

}



const register = async ( idAtencion, dataDescansos ) => {

  if( !idAtencion ) {
    console.error('id atencion es requerido');
    return null
  }

  if( !dataDescansos || dataDescansos.length === 0 ) {
    console.error('data descanso es requerido');
    return null
  }

  const query = `
    mutation crearDescanso(
      $atencionMedica : ID!, 
      $dataDescansos  : [DescansoInput!]!
    ) {
      crearDescanso(
        atencionMedica : $atencionMedica, 
        dataDescansos  : $dataDescansos 
      ) {
        descansos {
          token
          id 
        }
        status
        message
      }
    }
  `;

  const variables = {
    dataDescansos,
    atencionMedica: idAtencion,
  };


  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    // console.log('response descanso', response);

    if( response.status !== 200 ) return null;

    const response2 = response.data.data.crearDescanso;
    if( response2.status !== 'SUCCESS' ) return null;

    const data = response2.descansos;
    return data;
  }catch(error){
    console.error('Error al registrar descanso medico', error);
    return null;
  }
}

const update = async ( dataDescansos, atencionMedica ) => {

  
  if( !dataDescansos || dataDescansos.length === 0 ) {
    console.error('data descanso es requerido');
    return null
  }

  const query = `
    mutation editarDescanso(
      
      $dataDescansos  : [DescansoUpdateInput!]!,
       $atencionMedica : ID!, 
    ) {
      editarDescanso(
        
        dataDescansos  : $dataDescansos,
        atencionMedica : $atencionMedica 
      ) {
        descansos {
          token
          id 
        }
        status
        message
      }
    }
  `;

  const variables = {
    dataDescansos,
    atencionMedica
    
  };


  try {
    const response = await axios.post(rutas.axios + "api", { query, variables });
    // console.log('response descanso', response);

    if( response.status !== 200 ) return null;

    const response2 = response.data.data.editarDescanso;
    if( response2.status !== 'SUCCESS' ) return null;

    const data = response2.descansos;
    return data;
  }catch(error){
    console.error('Error al editar el descanso medico', error);
    return null;
  }
}



const getAllByPaciente = async (idPaciente) => {

  const query = `
    query AllDescanso($idPaciente: ID) {
      allDescanso(idPaciente: $idPaciente) {
        id
        fechaCreacion
        token
        diasdescanso
        consultacita {
          id
          cita {
            id
            paciente {
              id
              token
            }
            doctor {
              id
              idPersona {
                primerApellido
                primerNombre
              }
            }
          }
        }
      }
    }

  `;

  const variables = { idPaciente };

  try{

    const response = await axios.post(rutas.axios + "api", { query, variables });
    if( response.status !== 200 ) return null;
    const data = response.data.data?.allDescanso;
    return data;
  }catch(error){
    console.error('Error al obtener todos los descansos by paciente', error);
    return null
  }
}


export const descansoMedicoService = {
  getByAtencion,
  getAllByPaciente,
  register,
  update
}